import {
  Typography,
  TypographyVariant,
  TypographyWeight,
} from 'src/components/atoms'

export interface ISimpleUpdatesItem {
  id: string
  title: string
  relativeTime: string
  subtitle?: string
  pdfUrl?: string
}

export interface ISimpleUpdatesEmptyState {
  title: string
  description: string
}

export interface ISimpleUpdatesListProps {
  items: ISimpleUpdatesItem[]
  onRowClick?: (item: ISimpleUpdatesItem) => void
  emptyState?: ISimpleUpdatesEmptyState
}

const SimpleUpdatesRowContent = ({
  item,
}: {
  item: ISimpleUpdatesItem
}): JSX.Element => {
  return (
    <>
      <Typography
        variant={TypographyVariant.title2Xs}
        weight={TypographyWeight.light}
        className="line-clamp-3 flex-1 text-content-primary"
      >
        {item.title}
      </Typography>
      <Typography
        variant={TypographyVariant.bodyXs}
        className="shrink-0 text-right text-content-secondary"
      >
        {item.relativeTime}
      </Typography>
    </>
  )
}

export const SimpleUpdatesList = ({
  items,
  onRowClick,
  emptyState,
}: ISimpleUpdatesListProps): JSX.Element => {
  if (items.length === 0 && emptyState) {
    return (
      <div className="flex min-h-[200px] items-center justify-center rounded-xl bg-state-hover-surface">
        <div className="flex flex-col items-center gap-1 text-center">
          <Typography variant={TypographyVariant.title2Xs}>
            {emptyState.title}
          </Typography>
          <Typography
            variant={TypographyVariant.bodyXs}
            className="text-content-secondary"
          >
            {emptyState.description}
          </Typography>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full divide-y divide-border-default border-y border-border-default">
      {items.map(
        (item): JSX.Element => (
          <article key={item.id}>
            {onRowClick ? (
              <button
                type="button"
                className="flex h-[84px] w-full cursor-pointer items-center gap-4 border-0 bg-transparent px-3 text-left transition-colors hover:bg-state-hover-surface"
                onClick={(): void => onRowClick(item)}
              >
                <SimpleUpdatesRowContent item={item} />
              </button>
            ) : (
              <div className="flex h-[84px] items-center gap-4 px-3 transition-colors hover:bg-state-hover-surface">
                <SimpleUpdatesRowContent item={item} />
              </div>
            )}
          </article>
        ),
      )}
    </div>
  )
}
